import React from "react";
import PropTypes from "prop-types";
import { Tooltip as MUITooltip, Typography } from "@mui/material";

const Tooltip = ({ title, children, ...props }) => {
  return (
    <MUITooltip
      title={<Typography variant="body2">{title}</Typography>}
      PopperProps={{
        disablePortal: true,
        sx: { width: "max-content" },
      }}
      {...props}
    >
      {children}
    </MUITooltip>
  );
};

Tooltip.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
};

export default Tooltip;
